import { createSlice } from "@reduxjs/toolkit";
import { update } from "firebase/database";

export const userSlice = createSlice({
    name: "user",
    initialState: {
        uid: null,
        email: null,
        displayName: null,
        people: [],
        currentPersonId: null,
        isAdmin: false,
        impersonate: null,
    },
    reducers: {
        updateUserSettings: (state, action) => {
            state.uid = action.payload.uid;
            state.email = action.payload.email;
            state.displayName = action.payload.displayName;
            state.people = action.payload.people;
            state.currentPersonId = Boolean(action.payload.personId) ? action.payload.personId : (
                Boolean(action.payload.people) && action.payload.people.length > 0 ? action.payload.people[0].id : null
            );
            state.isAdmin = action.payload.isAdmin;
            state.impersonate = null;
        },
        clearUserSettings: state => {
            state.uid = null;
            state.email = null;
            state.displayName = null;
            state.people = [];
            state.currentPersonId = null;
            state.isAdmin = false;
            state.impersonate = null;
        },
        updateCurrentPersonId: (state, action) => {
            state.currentPersonId = action.payload;
        },
        updateFromImpersonate: (state, action) => {
            state.people = action.payload.people;
            state.currentPersonId = Boolean(action.payload.personId) ? action.payload.personId : (
                Boolean(action.payload.people) && action.payload.people.length > 0 ? action.payload.people[0].id : null
            );
            state.impersonate = action.payload.impersonate;
        },
        updatePersonConfirmation: (state, action) => {
            const person = state.people.find(element => element.id === action.payload);
            if (Boolean(person)) {
                person.confirmed = true;
            }
        },
        updatePersonCard: (state, action) => {
            const person = state.people.find(element => element.id === action.payload.personId);
            if (Boolean(person)) {
                person.cardUrl = action.payload.cardUrl;
            }
        },
    }
});

// Action creators are generated for each case reducer function
export const { updateUserSettings, clearUserSettings, updateCurrentPersonId, updateFromImpersonate, updatePersonConfirmation, updatePersonCard } = userSlice.actions
export default userSlice.reducer;
